"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTOMATION_LOOKUP_KEY_RULES = exports.AUTOMATION_ROW_KEY_RULES = void 0;
exports.matchAutomationAuto = matchAutomationAuto;
exports.matchAutomationKeys = matchAutomationKeys;
exports.automationLookupRowId = automationLookupRowId;
/**
 * How an automation finds rows by the values of its answer: the `auto` chain
 * for one value, the AND of several keys, and the row a relation takes. Pure:
 * the caller searches (the platform in its tables, the local run of
 * `sl-streamkit` in the seed rows), these rules decide what the hits mean.
 */
const output_targets_1 = require("./output-targets");
/**
 * `auto`: the first mode of the chain that finds rows decides. Several rows
 * stay several; a broader mode is only tried where a narrower found none.
 */
async function matchAutomationAuto(search) {
    for (const mode of output_targets_1.AUTOMATION_AUTO_MATCH_CHAIN) {
        const rows = await search(mode);
        if (rows.length === 1)
            return { kind: 'one', row: rows[0], mode };
        if (rows.length > 1)
            return { kind: 'several', rows, mode };
    }
    return { kind: 'none' };
}
/** The keys of an `update_by_match` or `upsert` target. */
exports.AUTOMATION_ROW_KEY_RULES = {
    emptyKey: 'no-row',
    trim: false,
    laterAutoExact: true,
};
/** The keys of a relation lookup. */
exports.AUTOMATION_LOOKUP_KEY_RULES = {
    emptyKey: 'skip',
    trim: true,
    laterAutoExact: false,
};
/**
 * The rows all keys find (AND): each key searches its value, the hits of the
 * keys are intersected, an empty intersection stops. `ids` lists the rows
 * every key found, `rows` the found rows by their ID.
 */
async function matchAutomationKeys(input) {
    const { keys, rules, valueOf, match } = input;
    const rows = new Map();
    let surviving = null;
    for (const [index, key] of keys.entries()) {
        const raw = valueOf(key);
        const text = raw === null || raw === undefined
            ? ''
            : rules.trim
                ? String(raw).trim()
                : String(raw);
        if (!text) {
            if (rules.emptyKey === 'skip')
                continue;
            return { ids: [], rows };
        }
        const mode = rules.laterAutoExact && index > 0 && key.matchMode === 'auto'
            ? 'exact'
            : key.matchMode;
        const found = await match(key, text, mode);
        for (const row of found)
            rows.set(row.id, row);
        const ids = new Set(found.map(row => row.id));
        surviving = surviving
            ? new Set([...surviving].filter(id => ids.has(id)))
            : ids;
        if (surviving.size === 0)
            break;
    }
    return { ids: surviving ? [...surviving] : [], rows };
}
/**
 * The row a relation takes for what its keys found: the one row, or with
 * `update_first` the first of several; null where a person decides.
 */
function automationLookupRowId(found, multiMatchBehavior) {
    if (found.rowId)
        return found.rowId;
    if (found.candidates?.length && multiMatchBehavior === 'update_first')
        return found.candidates[0];
    return null;
}
//# sourceMappingURL=row-match.js.map